<div class="support-banner-container" [ngClass]="[topStyle, background]" style="background-size: cover; background: url('./assets/background/customer_support_banner_background.png') no-repeat bottom;">
  <div class="content">
    <div class="support">
      <div class="centered">
        <div class="start">
          <kion-headline-tag
            *ngIf="title"
            [title]="title.title"
            [titleSize]="title.titleSize"
          ></kion-headline-tag>
          <p>{{ subtitle }}</p>
        </div>
        <div class="end">
          <h2 class="phone"><kion-link [linkRef]="'tel:' + support.phone " [alternativeText]="support.phone"></kion-link></h2>
          <div class="icon-info">
            <img src="./assets/icons/support_icon.svg" alt="support_icon" title="support_icon">
            <div class="info-text">
              <p class="bold" [innerHTML]="'customerSupport.hotline.description' | translate: { openingHours: openingHours}"></p>
            </div>
          </div>
          <div class="icon-info">
            <img src="./assets/icons/mail_icon.svg" alt="mail_icon" title="mail_icon">
            <div class="info-text">
              <p [innerHTML]="'customerSupport.email.description' | translate: {email: emailLink}"></p>
            </div>
          </div>
          <div class="icon-info">
            <img src="./assets/icons/file_icon.svg" alt="file_icon" title="file_icon">
            <div class="info-text">
              <p [innerHTML]="'customerSupport.contact.description' | translate: {contactLink: faqLink}"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
